/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const NoFieldEditorAvailable = (props) => {
    
    const field = props?.field;
    const type = field?.type;
    const name = field?.name;
    
    return (
        <p className='simplicity-missing-type'>
            <span>&#128039;</span> Field {name} of type: {type} does not have an editing component.
        </p>
    );
};

export { NoFieldEditorAvailable };
